export default __webpack_public_path__ + "static/media/Img0017.e217f6d0.png";